import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationNishikanPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationNishikan,
);
